import React from 'react';
import { Field, useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import { useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import WithError from '../../../../components/with-error/WithError';
import TooltipButton from '../../../../components/tooltip-button/TooltipButton';
import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';

import scss from '../ProjectRequestForm.module.scss';

function FieldWithUserInfo({ name, label, isRequired, infoSelector, children }) {
  const { t } = useTranslation('projectRequest');

  const userInfo = useSelector(infoSelector);

  const { input: contactEmailInput } = useField(name);

  const handleUseAccountData = () => {
    contactEmailInput.onChange(userInfo);
  };

  return (
    <div className={scss.fieldWithUserInfo}>
      <Field name={name}>
        {({ input, meta }) => (
          <WithLabel
            label={label}
            variant={LABEL_STYLES.COLUMN}
            isBold
            isRequired={isRequired}
            isTwoDots
            extraClassName={scss.commonField}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              {children({ input, meta })}
            </WithError>
          </WithLabel>
        )}
      </Field>

      <TooltipButton
        styleColor={BUTTON_STYLES.SECONDARY}
        onClick={handleUseAccountData}
        maxWidth={36}
        tooltip={t('useAccountData')}>
        <PermIdentityIcon />
      </TooltipButton>
    </div>
  );
}

export default FieldWithUserInfo;
